export class AppSelectItems {
    /**
     * 当isServerData=false时，此SelectItem元素为一个静态列表，可以有多个，Text表示为显示的内容，Value表示显示内容的值。
     * 当isServerData=true时，此SelectItem元素为数据绑定列表，只可有一个，Text表示为显示的内容绑定为对应的gridViewConfigName
     * 下的字段，Value表示显示内容的值绑定为对应的gridViewConfigName下的字段
     */
    text: string;
    /**
     * 默认值
     */
    value: string;
    /**
     * 转换字段
     */
    bindingField:string;
    /**
     * 数据库字段
     */
    field: string;
    /**
     * 自定义图标
     */
    icon: string;
    /**
     * 显示方式
     */
    align: string;
    /**
     * 是否支持排序
     */
    sortable: boolean;
    /**
     * 格式化文本
     */
    formatter: string;
    /**
     * 列显示还是隐藏
     */
    visible: boolean;
    /**
     * 样式
     */
    class: string;
    /**
     * 排列顺序
     */
    level: string;
    /**
     * 是否标题
     */
    head: boolean;
    /**
     * 不可编辑
     */
    readonly: boolean=false;
    /**
     * 控件类型
     */
    elementType: any;
}